import arrowback from "../../assets/svg/arrow-back.svg";

const ChatBotBar = ({
  leftText,
  rightText,
  title,
  onClickPop,
  onClickLeft,
  onClickRight,
}) => {
  return (
    <div className="h-[70px] flex items-center justify-between px-6 bg-white">
      <div className="flex items-center gap-2 text-gray-700">
        <img
          src={arrowback}
          alt="arrow-back"
          className="w-10 h-10 p-2 rounded-full hover:bg-gray-100 cursor-pointer transition"
          onClick={onClickPop}
        />
        <span className="text-xl pl-3 font-omny font-semibold">{title}</span>
      </div>

      <div className="flex items-center gap-3">
        {leftText && (
          <button
            onClick={onClickLeft}
            className="px-4 py-2 text-sm rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition font-semibold font-omny"
          >
            {leftText}
          </button>
        )}

        {rightText && (
          <button
            onClick={onClickRight}
            className="px-4 py-2 text-sm rounded-full bg-[#007DFE] text-white hover:bg-blue-600 transition font-semibold font-omny"
          >
            {rightText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatBotBar;
